// @ts-nocheck

  import SettingOutlined from '@ant-design/icons/es/icons/SettingOutlined'
  export default {
    SettingOutlined
  }